import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import CustomButtons from '../Elements/Buttons/customButton';
import TableHeader from '../pay/tableHeader';
import ApiService from '../../services/ApiService';
import axios from 'axios';
import { API_URL } from '../../config';

const OverduePay = (props) => {
    const [res, setRes] = useState();
    const [toPay, setToPay] = useState([]);
    const [amountFree, setAmount] = useState(0);
    const apiService = ApiService.getInstance();
    const history = useHistory();
    const proxySendURL = `${API_URL}ProxySend`;
    const userIDCONST = localStorage.getItem("userID");
    const config = { usersID: localStorage.getItem('usersID'), current_LocalizationsID: -1 };
    const[selecedLocation, setSelectedLocation] = useState("");
    const configPay = {
        headers: { Authorization: 'Bearer ' + `${localStorage.getItem('token')}` },
    };
    let mainLoaderTaskId;
    let globalResponse;
    let amount = 0;
    let test = [];
    let paymentList = ""
    const payload = {
        keyController: 'getAllPaymets',
        usersID: userIDCONST,
        current_LocalizationsID: '0',
    };
    
    const methodProxySend = () => {
        console.log(userIDCONST)

        apiService.apiPost('CalculateProductForUser', payload, (response) => {
            if (response.success) {
                
                setRes(response.data.responseBody.body);
            }
        });
    };
    useEffect(() => {
            methodProxySend();
    }, []);

    function pay(el) {
       
        mainLoaderTaskId = apiService.startLoaderTask();


        toPayChange(res[0]);
    }

    const toPayChange = (el) => {
        const formData = {
            keyController: 'onLineSchedulePayment',
            usersID: el.usersID,
            current_LocalizationsID: '-1',
            NIP: '',
            paymentMethodsDVID: '5',
            product: {
                productsID: el.productsID,
                localizationsID: el.localizationsID,
            },
            localizationsID: el.localizationsID,
            usersPaymentsSchedulesID: el.usersPaymentsSchedulesID,
        };

        apiService.apiPost('CalculateProductForUser', formData, (response) => {
       
            window.location.replace(response.data.responseBody.body.html);
        });

    };

    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, configPay)
            .then((proxyGetMessageUrlResponse) => {
                
                if (proxyGetMessageUrlResponse.data.recheck == false) {
                    if (proxyGetMessageUrlResponse.data.responseBody.body.html) {
                        window.location.replace(
                            proxyGetMessageUrlResponse.data.responseBody.body.html
                        );
                    } else if (proxyGetMessageUrlResponse.data.responseBody.body.key === 20) {
                        apiService.stopLoaderTask(mainLoaderTaskId);
                        history.push(
                            `/Potwierdzenie_zakupu/${proxyGetMessageUrlResponse.data.responseBody.body.sessionID}`
                        );
                    } else {
                        history.push(`/Potwierdzenie_zakupu`);

                        apiService.stopLoaderTask(mainLoaderTaskId);
                    }
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 5000);
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        history.push('/Error_sesja_wygasla');

                        apiService.stopLoaderTask(mainLoaderTaskId);
                    }
                } else {
                    window.location.replace(
                        
                        'https://panelklienta.egurrola.com/Error_ogolny'
                    );

                    apiService.stopLoaderTask(mainLoaderTaskId);
                }
            });
    };

    function comapreDates(d, p) {
        const x = new Date();
        const y = new Date(d);

        if (x < y) {
         
            return false;
        } else {
       
            return true;
        }
    }
    const payWithoutProxy = (el) => {
        
        apiService.apiPost('CalculateProductForUser', el, (response) => {
            
            if(response.data.responseStatusCode == 200){
               
                if(response.data.responseBody.body){
                    
                window.location.replace(response.data.responseBody.body.html)}
                else{
                    
                    props.setMsg(
                        {
                        title:"Nie udało się przygotowować płatności!",
                        msg:"Sprawdź czy wybrałeś rate i spróbuj ponownies."
                        }
                    )
                    if (props.modalClass == 'modal hidden') {
                      
                        props.showModal('modal');
                    } else {
                      
                        props.showModal('modal hidden');
                    }
                }
            }
                else{
                    props.setMsg(
                        {
                        title:"Nie udało się przygotowować płatności!",
                        msg:"Sprawdź czy wybrałeś rate i spróbuj ponownies."
                        }
                    )
                    if (props.modalClass == 'modal hidden') {
                      
                        props.showModal('modal');
                    } else {
                      
                        props.showModal('modal hidden');
                    }
                }
        });
    
};

    function calculateAmount(data, p, a, user, payer) {
        
        if (comapreDates(data)) {
          
            test.push(p);
            if(paymentList === ""){
            paymentList += payer + "/" + user + "/" + p}else{
                paymentList += "," + payer + "/" + user + "/" + p
            }
            amount += a;
        }
      
    }


    return (
        <>
        <div className="filter_eventList">
            <p  style={{ color: 'black' }}>Pokaż dla:</p>
            <select className="select_filterEventList" onChange={(e)=>{setSelectedLocation(e.target.value); paymentList = ""}}>
      
                {
                    
                  res!= undefined?Object.keys(res).map(function(key, index)  {
                    
                    if(index == 0&&selecedLocation == ""){
                        
                        setSelectedLocation(key)
                    }
                    if(key != ""){
                    return <option key={index +""+index} value={key}>{key}</option>}
                  }):""  
                }
            </select>
        </div>
            <div className="responsive-table margin-top-8">
                <div className="responsiveTableWrapper">
                <table>
                    <thead className="boardHead">
                        <tr className="headTable_installemnt ">
                            <th style={{ width: '10%' }}>Typ umowy</th>
                            <th style={{ width: '10%' }}>Nr umowy</th>
                            <th style={{ width: '10%' }}>Nazwa pozycji</th>
                            <th style={{ width: '10%' }}>Uczestnik</th>
                            <th style={{ width: '10%' }}>Termin płatności</th>
                            <th style={{ width: '10%' }}>Kwota całościowa</th>
                            <th style={{ width: '10%' }}>Wybierz</th>
                        </tr>
                    </thead>
                    <tbody className="board">
               
                    {res!=undefined && res[selecedLocation] != ""? res[selecedLocation]?.map((pay, index)=>{
                       
                         if (pay.paymentStatusesDVID == 1) {
                            
                            calculateAmount(
                                pay.paymentDate,
                                pay.usersPaymentsSchedulesID,
                                pay.paymentAmount,
                                pay.usersID,
                                pay.payer_UsersID
                            );
                            return (
                                <tr key={index} className="oddRowTable_installemnt">
                                    <td style={{ width: '10%' }}>{pay.contractPatternName}</td>
                                    <td style={{ width: '10%' }}>{pay.contractSygnature}</td>
                                    <td style={{ width: '10%' }}>{pay.productName}</td>
                                    <td style={{ width: '10%' }}>{pay.UserFullName}</td>
                                    <td style={{ width: '10%' }}>{pay.paymentDate}</td>
                                    <td style={{ width: '10%' }}>
                                        {pay.paymentAmount.toFixed(2).toString().replace(".",",")}
                                    </td>
                                    <td style={{ width: '10%' }}>
                                        <div className="iconCheckWrapper">
                                            {comapreDates(pay.paymentDate) ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="iconChecked"
                                                    fill="#666"
                                                    viewBox="0 0 36 36"
                                                >
                                                    <path d="M25 0H7a7 7 0 0 0-7 7v18a7 7 0 0 0 7 7h18a7 7 0 0 0 7-7V7a7 7 0 0 0-7-7zm5 25a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5h18a5 5 0 0 1 5 5z" />
                                                    <path d="m13 20.59-4.29-4.3-1.42 1.42 5 5a1 1 0 0 0 1.41 0l11-11-1.41-1.41z" />
                                                </svg>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        }
                    }):<tr></tr>}
                        
                    </tbody>
                </table>
                </div>
            </div>
            <div className="summaryToPay">
                <div className="summaryToPay_amount">
                    <p className="summaryToPay_toPay">Do zapłaty:</p>
                    <p>{(amount + amountFree).toFixed(2).toString().replace(".",",")} zł</p>
                </div>
                <CustomButtons clickFunction={()=>{
                   
                    payWithoutProxy(
                        {
                            keyController: 'onLineSchedulePayment',
                            usersID: props.userID,
                            current_LocalizationsID: '-1',
                            NIP: '',
                            paymentMethodsDVID: '5',
                          
                            usersPaymentsSchedulesID: paymentList,
                            urlLink: "https://aden-eds-portal-dev.azurewebsites.net/Pulpit"
    }
                    )
                }} size="big" classButton="solid">
                    Opłać
                </CustomButtons>
            </div>
        </>
    );
};

export default OverduePay;
